import React, {FC} from "react"
import getProductDetails from "@irati/products/utils/getProductDetails"
import {getActiveProducts} from "@irati/products/utils/products"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {PerkboxLogo} from "@irati/ui/src/Logos"
import PropTypes from "prop-types"
import Flex from "@irati/ui/src/Flex"
import {H4, H5, Label} from "@irati/ui/src/Typography"
import Products from "@irati/products/enums/Products"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import tracking from "@irati-tracking/platform"

import {StyledBusinessLogoWrapper, StyledLogo, StyledLogoContainer, StyledRouterLink} from "./styled"

interface Context {
  apps: {[key: string]: string},
  appPath: string
}

interface Props extends InjectIntl {
  onClick?: () => void,
  isSidebarNavigation?: boolean,
  businessLogoUrl?: string
}

const getIconForProduct = (product: Products, isSelected: boolean) => {
  switch (product) {
    case Products.perks:
      return isSelected ? IconTypes.perksFill : IconTypes.perks
    case Products.recognition:
    case Products.rewards:
      return isSelected ? IconTypes.celebrationFill : IconTypes.celebration
    case Products.medical:
      return isSelected ? IconTypes.medicalFill : IconTypes.medical
    case Products.wellness:
      return isSelected ? IconTypes.wellnessFill : IconTypes.wellness
  }
}

const NavigationMenuContent: FC<Props> = ({formatMessage, onClick, isSidebarNavigation, businessLogoUrl}, {apps, appPath}: Context) => {
  const activeProducts = getActiveProducts()
  const {HOME} = apps
  const isHomeSelected = appPath === HOME

  const handleOnClick = (trackingName: string) => {
    tracking.click("homepage_card", {product: trackingName, active: true, source: "menu"})
    if (onClick) {
      onClick()
    }
  }

  const TitleWrapper = isSidebarNavigation ? H5 : H4

  return (
    <>
      {isSidebarNavigation && businessLogoUrl && (
        <StyledBusinessLogoWrapper>
          <StyledLogo src={businessLogoUrl} />
        </StyledBusinessLogoWrapper>
      )}
      <Flex direction="column" padding={[2, 2, 0, 2]}>
        <div>
          <StyledRouterLink
            isSidebarNavigation={isSidebarNavigation}
            id="HOME_LINK"
            isSelected={isHomeSelected}
            app={HOME}
            to="/"
            onClick={() => handleOnClick("home")}>
            <Icon icon={isHomeSelected ? IconTypes.homeFill : IconTypes.home} size={24} />
            <TitleWrapper marginLeft={2} weight="bold">{formatMessage({id: "platform.home.title"})}</TitleWrapper>
          </StyledRouterLink>
          {activeProducts.map(({product, trackingName}, index) => {
            const productDetails = getProductDetails(formatMessage)[product]
            const isSelected = appPath === apps[product]
            return productDetails ? (
              <StyledRouterLink
                isSidebarNavigation={isSidebarNavigation}
                key={index}
                id={`${product}_LINK`}
                isSelected={isSelected}
                app={apps[product]}
                to="/"
                onClick={() => handleOnClick(trackingName)}>
                <Icon icon={getIconForProduct(product, isSelected)} size={24} />
                <TitleWrapper marginLeft={2} weight="bold">{productDetails.title}</TitleWrapper>
              </StyledRouterLink>
            ) : null
          })}
        </div>
        <StyledLogoContainer direction="column">
          <Label weight="bold" small marginBottom>{formatMessage({id: "platform.ui.poweredBy"})}</Label>
          <PerkboxLogo size={28} />
        </StyledLogoContainer>
      </Flex>
    </>
  )
}

NavigationMenuContent.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default injectIntl(NavigationMenuContent)
